import { assignTicketToTechRequest } from 'services/pod';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IAssignTicketPayload } from 'services/pod/types';

export const ThunkAssignTicketToTechRequest = createAsyncThunk(
  'pod/assignTicketToTechRequest',
  (payload: IAssignTicketPayload) => assignTicketToTechRequest(payload).then(res => res.data),
);

export default {};
